import materialsData from '../datas/materials.json';
import deprecatedMaterialsData from '../datas/deprecated-materials.json';
import woodtypesData from '../datas/woodtypes.json';
export const materials = materialsData;
export const deprecatedMaterials = deprecatedMaterialsData;
export const woodtypes = woodtypesData;
